/**
 * @generated SignedSource<<0dd49360b048fbbc133c64511bef422a>>
 * @relayHash b17b87df0361e2b091063266ad414333
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4

import type { ConcreteRequest } from 'relay-runtime';
export type ExtensionContextsFilterType = "APP_ID_ENVIRONMENT_ID" | "DATA_CLASSIFICATION_TAG" | "DEFINITION_ID" | "EXTENSION_TYPE" | "PRINCIPAL_TYPE" | "%future added value";
export type ExtensionContextsFilter = {
  type: ExtensionContextsFilterType;
  value: ReadonlyArray<string>;
};
export type publicEventsBridgeMethod_getExtensionListQuery$variables = {
  contextIds: ReadonlyArray<string>;
  filter: ReadonlyArray<ExtensionContextsFilter>;
};
export type publicEventsBridgeMethod_getExtensionListQuery$data = {
  readonly extensionContexts: ReadonlyArray<{
    readonly extensions: ReadonlyArray<{
      readonly appId: string;
      readonly key: string;
      readonly properties: AGG$JSON;
    }>;
  }> | null | undefined;
};
export type publicEventsBridgeMethod_getExtensionListQuery = {
  response: publicEventsBridgeMethod_getExtensionListQuery$data;
  variables: publicEventsBridgeMethod_getExtensionListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contextIds",
    "variableName": "contextIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "appId"
},
v4 = {
  "kind": "ScalarField",
  "name": "properties"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "publicEventsBridgeMethod_getExtensionListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "publicEventsBridgeMethod_getExtensionListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4",
    "metadata": {},
    "name": "publicEventsBridgeMethod_getExtensionListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7bbb57a8de2a877674c61a37fce31344";

export default node;
